/// <reference types="./utils.d.mts" />
import * as $connector from "../../common/data/connector.mjs";
import * as $unsafe from "../../common_common/gleam/unsafe.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $a from "../../lustre/lustre/attribute.mjs";
import * as $event from "../../lustre/lustre/event.mjs";
import * as $mime_types from "../../mime_types/mime_types.mjs";
import * as $css from "../../sketch/sketch/css.mjs";
import * as $el from "../../sketch_lustre/sketch/lustre/element.mjs";
import { platform, overflow as do_overflow } from "../ds.ffi.mjs";
import * as $brands from "../ds/brands.mjs";
import * as $icons from "../ds/icons.mjs";
import * as $logo from "../ds/logo.mjs";
import * as $outline from "../ds/outline.mjs";

export { platform };

export function stop_propagation() {
  let fail = $decode.failure($unsafe.coerce(""), "Stop Propagation");
  let _pipe = $event.on("click", fail);
  return $event.stop_propagation(_pipe);
}

export function is_mac() {
  let _pipe = platform();
  let _pipe$1 = $result.unwrap(_pipe, "");
  let _pipe$2 = $string.lowercase(_pipe$1);
  return $string.contains(_pipe$2, "mac");
}

export function select_icon(mime_type, kind) {
  if (kind instanceof $connector.GoogleDrive) {
    return $brands.drive();
  } else if (kind instanceof $connector.Confluence) {
    return $brands.confluence();
  } else if (kind instanceof $connector.Website) {
    return $icons.globe();
  } else if (kind instanceof $connector.Notion) {
    return $brands.notion();
  } else if (kind instanceof $connector.Steerlab) {
    if (mime_type instanceof $mime_types.Document) {
      return $brands.drive_icons.docs();
    } else if (mime_type instanceof $mime_types.Docx) {
      return $brands.office.word();
    } else if (mime_type instanceof $mime_types.Sheet) {
      return $brands.drive_icons.sheets();
    } else if (mime_type instanceof $mime_types.Xlsx) {
      return $brands.office.excel();
    } else if (mime_type instanceof $mime_types.Pptx) {
      return $brands.office.powerpoint();
    } else if (mime_type instanceof $mime_types.Pdf) {
      return $brands.pdf();
    } else if (mime_type instanceof $mime_types.Csv) {
      return $outline.file_list();
    } else if (mime_type instanceof $mime_types.Qna) {
      return $logo.round();
    } else if (mime_type instanceof $mime_types.Markdown) {
      return $brands.markdown();
    } else if (mime_type instanceof $mime_types.Proposal) {
      return $logo.round();
    } else {
      return $el.none();
    }
  } else if (kind instanceof $connector.SteerlabQna) {
    if (mime_type instanceof $mime_types.Document) {
      return $brands.drive_icons.docs();
    } else if (mime_type instanceof $mime_types.Docx) {
      return $brands.office.word();
    } else if (mime_type instanceof $mime_types.Sheet) {
      return $brands.drive_icons.sheets();
    } else if (mime_type instanceof $mime_types.Xlsx) {
      return $brands.office.excel();
    } else if (mime_type instanceof $mime_types.Pptx) {
      return $brands.office.powerpoint();
    } else if (mime_type instanceof $mime_types.Pdf) {
      return $brands.pdf();
    } else if (mime_type instanceof $mime_types.Csv) {
      return $outline.file_list();
    } else if (mime_type instanceof $mime_types.Qna) {
      return $logo.round();
    } else if (mime_type instanceof $mime_types.Markdown) {
      return $brands.markdown();
    } else if (mime_type instanceof $mime_types.Proposal) {
      return $logo.round();
    } else {
      return $el.none();
    }
  } else if (kind instanceof $connector.SteerlabProposal) {
    if (mime_type instanceof $mime_types.Document) {
      return $brands.drive_icons.docs();
    } else if (mime_type instanceof $mime_types.Docx) {
      return $brands.office.word();
    } else if (mime_type instanceof $mime_types.Sheet) {
      return $brands.drive_icons.sheets();
    } else if (mime_type instanceof $mime_types.Xlsx) {
      return $brands.office.excel();
    } else if (mime_type instanceof $mime_types.Pptx) {
      return $brands.office.powerpoint();
    } else if (mime_type instanceof $mime_types.Pdf) {
      return $brands.pdf();
    } else if (mime_type instanceof $mime_types.Csv) {
      return $outline.file_list();
    } else if (mime_type instanceof $mime_types.Qna) {
      return $logo.round();
    } else if (mime_type instanceof $mime_types.Markdown) {
      return $brands.markdown();
    } else if (mime_type instanceof $mime_types.Proposal) {
      return $logo.round();
    } else {
      return $el.none();
    }
  } else {
    return $el.none();
  }
}

export function overflow(value) {
  return $css.overflow(do_overflow(value));
}

export function overflow_x(value) {
  return $css.overflow_x(do_overflow(value));
}

export function overflow_y(value) {
  return $css.overflow_y(do_overflow(value));
}

export function optional_attribute(attri, mapper) {
  if (attri instanceof $option.Some) {
    let b = attri[0];
    return mapper(b);
  } else {
    return $a.none();
  }
}
